export default "__VITE_ASSET__CBJpsCWp__"